import { useNavigate, useOutletContext, useParams } from 'react-router-dom'

import { useQuery } from '@apollo/client'
import { QuotesListPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { QuotesListTable } from 'modules/finance/components/Quotes/QuotesListTable'
import { SalesRootPageOutletContext } from 'modules/finance/pages/SalesRootPage'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const QuotesListPage = () => {
  const {
    company: { id: companyId },
    access,
  } = useCurrentSession()
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { dealId } = useParams()
  const { routesVisibility: salesRootVisibility } = useOutletContext<SalesRootPageOutletContext>()
  const { data, error, loading } = useQuery(QuotesListPageDocument, {
    variables: {
      companyId,
    },
  })
  const authorized = salesRootVisibility.finance._policies.sidebarSeeFinanceQuotesSubLevelItem.can
  const hasQuickQuoteBuilderFeature = !!data?.features.featuresConnection.nodes.find(
    (feature) => feature.name === 'dev_quick_quote_builder'
  )?.enabled

  useEffect(() => {
    if (Number(dealId)) {
      track(trackingEvents.accounting.deals.viewDealQuotes)
    } else {
      track(trackingEvents.accounting.quotes.viewQuotesPage)
    }
  }, [])

  const handleClickAdd = () => {
    navigate(navigation.finance.sales.quotes.new.fullPath(), {
      state: { dealId: Number(dealId) },
    })
  }

  return (
    <ResponsivePage.Body authorized={authorized} variant="full" loading={loading} error={error}>
      <QuotesListTable
        companyId={companyId}
        locale={access.locale}
        dealId={dealId ? Number(dealId) : undefined}
        onClickAdd={handleClickAdd}
        showCustomerColumn
        hasQuickQuoteBuilderFeature={hasQuickQuoteBuilderFeature}
      />
    </ResponsivePage.Body>
  )
}

export default QuotesListPage
